import React from 'react';
import { ArrowRight, Download, Github, Linkedin, Mail, MapPin } from 'lucide-react';
import { personalInfo } from '../data/mock';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-greeting">Hello, I'm</div>
            <h1 className="hero-name">{personalInfo.name}</h1>
            <h2 className="hero-title">{personalInfo.title}</h2>
            <p className="hero-location">
              <MapPin className="location-icon" />
              {personalInfo.location}
            </p>
            <div className="hero-buttons">
              <Button
                className="btn-primary"
                onClick={() => scrollToSection('contact')}
              >
                Get In Touch
                <ArrowRight className="ml-2" size={20} />
              </Button>
              <Button
                className="btn-secondary"
                onClick={() => scrollToSection('projects')}
              >
                View Projects
              </Button>
              <Button
                className="btn-secondary"
                asChild
              >
                <a href="/RohanResume.pdf" download="RohanResume.pdf">
                  Download Resume
                  <Download className="ml-2" size={20} />
                </a>
              </Button>
            </div>
            <div className="hero-social">
              <a
                href={personalInfo.github}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <Github size={20} />
              </a>
              <a
                href={personalInfo.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <Linkedin size={20} />
              </a>
              <a
                href={`mailto:${personalInfo.email}`}
                className="social-link"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
          <div className="hero-image-wrapper">
            <div className="hero-image-container">
              <img
                src={personalInfo.heroImage}
                alt={personalInfo.name}
                className="hero-image"
              />
              <div className="hero-image-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;